(function () {
  'use strict';

  // Creator codes do not combine with the sitewide sale and take priority over it.
  // Email codes (e.g. RAVE5) stack with the sitewide sale while it is active.
  var FALLBACK_CODE = 'JULYSALE';
  var CREATOR_CAMPAIGN_CODES = {
    christy_brown: 'CHRISTY10',
  };
  var LEGACY_CREATOR_CODE_MIGRATIONS = {
    'CHRISTY&E': 'CHRISTY10',
  };
  var SALE_ENDS_AT = Date.parse('2026-08-01T06:59:59Z');
  var refreshKey = 'nr-july-sale-cart-refreshed';
  var preferKey = 'nr-preferred-discount';

  function launchSaleActive() {
    return Date.now() < SALE_ENDS_AT;
  }

  window.nrLaunchSaleActive = launchSaleActive();

  if (window.location.pathname !== window.Shopify.routes.root + 'cart') {
    window.sessionStorage.removeItem(refreshKey);
  }

  function normalizeCode(value) {
    return (value || '').toString().trim().toUpperCase();
  }

  function normalizeCreatorCode(value) {
    var normalized = normalizeCode(value);
    return LEGACY_CREATOR_CODE_MIGRATIONS[normalized] || normalized;
  }

  function isInfluencerCode(code) {
    return !!normalizeCreatorCode(code);
  }

  window.nrIsInfluencerCode = isInfluencerCode;

  function creatorCampaignCode() {
    try {
      var campaign = (new URLSearchParams(window.location.search).get('utm_campaign') || '')
        .trim()
        .toLowerCase();
      return CREATOR_CAMPAIGN_CODES[campaign] || '';
    } catch (e) {
      return '';
    }
  }

  function rememberInfluencerCode(code) {
    var normalized = normalizeCreatorCode(code);
    if (!normalized) return;
    try {
      window.sessionStorage.setItem(preferKey, normalized);
    } catch (e) {
      /* ignore quota / private mode */
    }
  }

  function rememberedInfluencerCode() {
    try {
      return normalizeCreatorCode(window.sessionStorage.getItem(preferKey));
    } catch (e) {
      return '';
    }
  }

  function urlDiscountCode() {
    try {
      var explicitCode = normalizeCode(new URLSearchParams(window.location.search).get('discount'));
      return explicitCode || normalizeCode(creatorCampaignCode());
    } catch (e) {
      return '';
    }
  }

  // Capture any ?discount= code on first paint so cart/clear + ATC still honor it.
  var fromUrl = urlDiscountCode();
  if (fromUrl) rememberInfluencerCode(fromUrl);

  function existingDiscountCodes(cart) {
    var codes = [];
    var seen = {};

    function add(raw) {
      var code = normalizeCode(raw);
      if (!code || seen[code]) return;
      seen[code] = true;
      codes.push(code);
    }

    var applications = cart.cart_level_discount_applications || [];
    for (var i = 0; i < applications.length; i += 1) {
      if (applications[i].type === 'discount_code') {
        add(applications[i].title);
      }
    }

    for (var itemIndex = 0; itemIndex < (cart.items || []).length; itemIndex += 1) {
      var allocations = cart.items[itemIndex].line_level_discount_allocations || [];
      for (var allocationIndex = 0; allocationIndex < allocations.length; allocationIndex += 1) {
        var application = allocations[allocationIndex].discount_application;
        if (application && application.type === 'discount_code') {
          add(application.title);
        }
      }
    }

    return codes;
  }

  function preferredDiscountCodes(cart) {
    var existing = existingDiscountCodes(cart);
    var preferred = normalizeCreatorCode(urlDiscountCode()) || rememberedInfluencerCode();
    var stackable = [];
    var seen = {};

    if (preferred) {
      rememberInfluencerCode(preferred);
      return [preferred];
    }

    function consider(raw) {
      var code = normalizeCreatorCode(raw);
      if (!code || seen[code] || code === FALLBACK_CODE) return;
      seen[code] = true;
      stackable.push(code);
    }

    for (var i = 0; i < existing.length; i += 1) {
      consider(existing[i]);
    }

    // After the launch sale, preserve cart codes without reapplying JULYSALE.
    return (launchSaleActive() ? [FALLBACK_CODE] : []).concat(stackable);
  }

  window.nrApplyJulySale = function () {
    return fetch(window.Shopify.routes.root + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to read cart discounts');
        }
        return response.json();
      })
      .then(function (cart) {
        var codes = preferredDiscountCodes(cart);
        return fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ discount: codes.join(',') }),
        });
      })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to apply discount');
        }
        return response.json();
      })
      .then(function (cart) {
        var cartPath = window.Shopify.routes.root + 'cart';
        if (
          window.location.pathname === cartPath &&
          !window.sessionStorage.getItem(refreshKey)
        ) {
          window.sessionStorage.setItem(refreshKey, 'true');
          window.location.reload();
        }
        return cart;
      });
  };

  window.nrJulySaleReady = window.nrApplyJulySale().catch(function (error) {
    console.warn(error);
  });
})();
